import { render, staticRenderFns } from "./tablasCoeficientes.vue?vue&type=template&id=6f5dd3ab"
import script from "./tablasCoeficientes.vue?vue&type=script&lang=js"
export * from "./tablasCoeficientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports